const CheckboxQuestionView = ({ question, ...rest }) => {
  return (
    <div
      className="bg-white p-4 rounded-3 shadow mb-4 assessment_question"
      {...rest}
    >
      <div className="mb-2"><i>Multi-Choice question</i></div>
      <pre className="mb-3 assessment_question_title_view">
        <strong>{question?.title}</strong>
      </pre>

      {question?.answers?.map((item) => {
        return (
          <div className="d-flex align-items-center mb-2">
            <div
              className={`assessment_checkbox_view ${
                question?.correct_answers.includes(item) ? "active" : ""
              }`}
            >
              <span className="assessment_checkbox_view_box"></span>
            </div>
            <div className="ml-3 mb-0">{item}</div>
          </div>
        );
      })}
    </div>
  );
};

export default CheckboxQuestionView;
